import { Navigate, useRoutes } from 'react-router-dom';

import { CONFIG } from 'src/config-global';

import { authRoutes } from './auth';
import { dashboardRoutes } from './dashboard';

export function Router() {
  return useRoutes([
    { path: '/', element: <Navigate to={CONFIG.auth.redirectPath} replace /> },
    ...authRoutes,
    ...dashboardRoutes,
    { path: '*', element: <Navigate to={CONFIG.auth.redirectPath} replace /> },
  ]);
}
